jQuery("document").ready(function ($) {
    // DI 2026-10-23 : nom de propriété français avec l'unité (« Largeur (po) » ou « Largeur (cm) »), lu tel quel à la caisse.
    // Sans effet en anglais (Width / Height n'ont pas de suffixe).
    function diNomsMesures() {
      var diSuffixe = $('#unit').val() == 'cm' ? '(cm)' : '(po)';
      $('#width, #height').each(function () {
        var nom = $(this).attr('name') || '';
        if (nom.indexOf('Largeur') > -1 || nom.indexOf('Hauteur') > -1) {
          $(this).attr('name', nom.replace(/\((po|cm)\)/, diSuffixe));
        }
      });
    }
    diNomsMesures();
    if($('#unit').val() == 'cm'){
      $('.text_cm').removeClass('hide');
      $('.text_pouce').addClass('hide');
    }else{
      $('.text_pouce').removeClass('hide');
      $('.text_cm').addClass('hide');
    }
    var e = window.location.href;
  //Init sezzle
    var PriceUnitaireInit = $(".product-init-price").attr("data-price-select");
    var QtyInit = $("#Quantity").val();
  if(!QtyInit){
      var QtyInit = $("#quantity").val();
  }
  //var PriceSezzleInit = (PriceUnitaireInit*QtyInit)/4;
  // if(window.location.href.includes("en.decorimprime.com") ){
  //  $('.sezzle-custom-widget-Trylea.lang-en').removeClass('hide'); 
  //   $('.sezzle-custom-widget-Trylea.lang-fr').addClass('hide'); 
  // }

   //$('.sezzle-custom-widget-Trylea span').text(Shopify.formatMoney(PriceSezzleInit));
function isNumeric(str) {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}
    function t() {
        if($('#measure-options').length){
          var height_user = $("#height_edit").val();
          var width_user = $("#width_edit").val();
          if(isNumeric(width_user) == true ){
            $("#width_edit").removeClass('error');
          }else{
            $("#width_edit").addClass('error');                     
          }
         
          if(isNumeric(height_user) == true ){
            $("#height_edit").removeClass('error');
          }else{
            $("#height_edit").addClass('error');                     
          }

          
          if($('#bleed').is(':checked')){
             var e = parseInt(height_user);
            var t = parseInt(width_user);
          }else{
            if($('#unit').val() == 'cm'){
               var e = parseInt(height_user)+5;
              var t = parseInt(width_user)+5;
            }else{
               var e = parseInt(height_user)+2;
            var t = parseInt(width_user)+2;
            }
            
          }    
        
          
        var n = $("#unit").val();
        var a = $("#fake_quantity").val();
        var o = 144;
        "cm" == n && (o = 929);
        if(n == "cm"){          
          var pt = Math.round((t/2.54)*100)/100 +'(' + t + 'cm)' ;
          var pe = Math.round((e/2.54)*100)/100 +'(' + e + 'cm)' ;
        }else{
          var pt = 0;
          var pe = 0;
        }
          $("#widthpouce").val(pt);
          $("#heightpouce").val(pe);
        var i = (e * t) / o;
        if (("" != e) & ("" != t)) {
          if( e != '' && e >= 1){
            $("#height").val(e);
          }
          if( t != '' && t >= 1){
            $("#width").val(t);
          }
          if($('.product-select option').length){
            var r = Math.ceil(i);
 
            var newSezzlePrice = ($(".product-select option:selected").attr("data-price") * r * a)/4;
           
            return Number.isNaN(r)
                ? ((document.getElementById("results").className = "number_error"),                   
                   !1)
                : ("inches" == n) & (e < 6 || t < 6) || ("cm" == n) & (e < 15 || t < 15)
                ? ((document.getElementById("results").className = "size_error"), !1)
                : ((document.getElementById("results").className = "total"),
                  $(".total_price").html(Shopify.formatMoney($(".product-select option:selected").attr("data-price") * r * a, $("html").attr("data-currency-format"))),
                  $("#Quantity").val(r),
                   // $('.sezzle-custom-widget-Trylea span').text(Shopify.formatMoney(newSezzlePrice)),
                  !0);

             }else{
            
            var r = Math.ceil(i);
             //var newSezzlePrice = ($(".product-init-price").attr("data-price-select") * r * a)/4;
              return Number.isNaN(r)
                ? ((document.getElementById("results").className = "number_error"), !1)
                : ("inches" == n) & (e < 6 || t < 6) || ("cm" == n) & (e < 15 || t < 15)
                ? ((document.getElementById("results").className = "size_error"), !1)
                : ((document.getElementById("results").className = "total"),
                  $(".total_price").html(Shopify.formatMoney($(".product-init-price").attr("data-price-select") * r * a, $("html").attr("data-currency-format"))),
                  $("#Quantity").val(r),
                   // $('.sezzle-custom-widget-Trylea span').text(Shopify.formatMoney(newSezzlePrice)),
                  !0);
            }
        }
        

       
        return (document.getElementById("results").className = "blank_error"), !1;
        }else{//Produit non mesurable
           if($('.product-select option').length){
             var quantitySelect = $('#quantity').val();
             //var newSezzlePrice = ($(".product-select option:selected").attr("data-price") * quantitySelect )/4;
             //$('.sezzle-custom-widget-Trylea span').text(Shopify.formatMoney(newSezzlePrice));
           }else{
             var quantitySelect = $('#quantity').val();
             //var newSezzlePrice = ($(".product-init-price").attr("data-price-select") * quantitySelect )/4;
             //$('.sezzle-custom-widget-Trylea span').text(Shopify.formatMoney(newSezzlePrice));
           }
        }
    }
    /*(e.indexOf("livraison-et-retour") >= 0 || e.indexOf("affiliation") >= 0) && $(".main-content").after("<style>.main-content .breadcrumbs{display:none;}</style>"),*/
        (e.indexOf("policies") >= 0 || e.indexOf("page") >= 0) &&
            $(".main-content").after("<style>" + ".main-content .shopify-policy__title h1, .main-content .shopify-section section h2:nth-of-type(1){font-family: Montserrat,sans-serif;}" + "</style>"),
        $("#unit").on("change", function () {
            $("#unit-real").val($(this).find("option:selected").text());
            diNomsMesures();

            if($(this).val() == 'cm'){
              $('.text_cm').removeClass('hide');
              $('.text_pouce').addClass('hide');
            }else{
              $('.text_pouce').removeClass('hide');
              $('.text_cm').addClass('hide');
            }
        }),
        $("#height_edit, #width_edit, #unit, #fake_quantity,#bleed").on("change keyup paste", function () {
            t();
        }),
        // DI 2026-06-29 — Mesures: chiffres entiers seulement. Bloque en direct point, virgule, lettres et espaces.
        $("#width_edit, #height_edit").on("input", function () {
            var original = $(this).val();
            var cleaned = original.replace(/[^0-9]/g, "");
            if (cleaned !== original) {
                $(this).val(cleaned);
                var $hint = $("#measurements-integer-hint");
                $hint.stop(true, true).show();
                clearTimeout(window._diIntHintTimer);
                window._diIntHintTimer = setTimeout(function () { $hint.fadeOut(200); }, 2500);
                t();
            }
        }),
      $(".shopify-product-form .qtyBtn").click( function () {
            t();
        }),
            $("[data-measureable-product]").length > 0 &&
            $(".shopify-product-form").on("submit", function (e) {
              if($('#results').hasClass("total")){
                return (
                    e.preventDefault(),
                  $('body').addClass('loading'),
             
                    t() &&
                        ((cc = $("#fake_quantity").val()),
                        (Shopify.moveAlong = function () {
                            cc > 0
                                ? ($("#group").val(Date.now()),
                                  $.ajax({
                                      type: "POST",
                                      url: "/cart/add.js",
                                      data: $(".shopify-product-form").serialize(),
                                      dataType: "json",
                                      error: function (t) {
                                          (e = JSON.parse(t.responseText)), $("#global-loading").removeClass("active"), (desc = e.description), Shopify.moveAlong();
                                      },
                                      success: function (e) {
                                          cc--, Shopify.moveAlong() ;
                                      },
                                  }))
                                : (updateminicartcontent());
                        }),
                        Shopify.moveAlong()),
                    !1
                );
              }else if($('#results').hasClass("number_error") || $('#results').hasClass("size_error")){
                 return (
                   e.preventDefault()
                  
                );
              }else{
                return (
                   e.preventDefault(),
                  $('#results').addClass('blank_error')
                );
              }
                
            });
            $("[data-measureable-product]").length == 0 &&
            $(".shopify-product-form").on("submit", function (e) {
                return (
                    e.preventDefault(),
                  $('body').addClass('loading'),
             
                   
                      $.ajax({
                          type: "POST",
                          url: "/cart/add.js",
                          data: $(".shopify-product-form").serialize(),
                          dataType: "json",
                          error: function (t) {
                              (e = JSON.parse(t.responseText)), $("#global-loading").removeClass("active"), (desc = e.description), Shopify.moveAlong();
                          },
                          success: function (e) {
                             updateminicartcontent() ;
                          },
                      })
                );
            });
 /*$(".italic").click(function(e){
   console.log("TEST");
 });*/
  function NewSwatchSelect(){
     var variantionPrice = $(".product-select option:selected").attr("data-price");
      if($('#measure-options').length > 0){
        var widthMural = $('#measure-options #width').val();
        var heightMural = $('#measure-options #height').val();
        if(!widthMural > 0){
          widthMural = 12;           
        }
        if(!heightMural > 0){
          heightMural = 12;           
        }  
        var a = $("#fake_quantity").val();
        var n = $("#unit").val();        
        var o = 144;
        "cm" == n && (o = 929);
        var i = (heightMural * widthMural) / o;
        var r = Math.ceil(i);//nb de pied carré        
             
        t(); // Changer le prix total

        if(! r >= 0){
          
            var newPrice = variantionPrice * 1;
        }else{
             var newPrice = variantionPrice * r * a;
        }
        //var newPriceSezzle  = newPrice / 4;
        // $(".sezzle-custom-widget-Trylea span").text(Shopify.formatMoney(newPriceSezzle));
      }else{
        var quantity_product = $('#quantity').val();
        
        //var newPrice = variantionPrice * r * a;
       // var newPriceSezzle  = (quantity_product*variantionPrice) / 4;
        // $(".sezzle-custom-widget-Trylea span").text(Shopify.formatMoney(newPriceSezzle));
      }
  }
  $('.swatch input[type="radio"]').change(function(){    
     var timer_swatch = setTimeout(NewSwatchSelect, 100);
    });
   $('#Quantity').change(function(){ 
    if($('#measure-options').length == 0){// Pour produits reguliers
      var qty = $('#Quantity').val();
      if($('.product-select option').length){
         var PriceUnitaire = $(".product-select option:selected").attr("data-price");
      }else{
         var PriceUnitaire = $("product-init-price").attr("data-price-select");
      }
      var newPrice = PriceUnitaire * qty ;
      var newComparePrice = $('.product-price-compare').attr("data-compareprice") * qty;
     // var newPriceSezzle  = newPrice / 4;

      
      $('.product-price-minimum-display').html(Shopify.formatMoney(newPrice));
      $('.product-price-compare').html(Shopify.formatMoney(newComparePrice));;
       // $(".sezzle-custom-widget-Trylea span").text(Shopify.formatMoney(newPriceSezzle));
    }
  });
  // $('.sezzle-custom-widget-Trylea').click(function(e){
  //   e.preventDefault();
    
  //   $('.sezzle-modal-link').click();
  // });
   /*Minicart edit*/
  /*TOP BAR */
   $('.Topbar').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 800,
          dots: false,
          infinite: true,
          focusOnSelect: true
        });
     $('.home-bar-hight.mobile .store-info').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 800,
          dots: false,
          infinite: true,
          focusOnSelect: true
        });
  $('.menu-search .searchIco-nav,.menu-search .searchIco-nav *').on('click', function(s){
     
      s.stopPropagation();
      $('body').addClass("showOverly");
      $('#searchPopup').addClass("active");
      $('input[name=q]').focus();
    });

  // CATALOGUE
 if(window.location.href.indexOf("catalogue-designer") > -1 || window.location.href.indexOf("sample-catalogue") > -1){
    
  
  var largeurWindow = window.innerWidth;

  if(largeurWindow <= 799){
      var langeurCatalogue = $('.catalogue-content').width();
    var hauteurCatalogue = (939*langeurCatalogue)/715; 
  }else{
      var langeurCatalogue = 715;
     var hauteurCatalogue = 939;
  }
  
    $("#flipbook").turn({
		// Width

    		width:langeurCatalogue,
			//width:1200,
			
			// Height

			height:hauteurCatalogue,

			// Elevation

			elevation: 50,
			duration: 1500,
			// Enable gradients

			// gradients: true,
			
			// Auto center this flipbook

			autoCenter: true,
     
            display : 'single' // Mobile uniquement
	});
  
  $(".catalogue-container .onglet-thematique").width(hauteurCatalogue);
  $('.prev-page').css('display','none');
  $('.toggle-ongle-them').click(function(e){
    
    if($(this).parent().find('.menu-container-them').hasClass('m-hide-thematique')){
      $(this).find('.ad-caret-up').addClass('hide');
      $(this).find('.ad-caret-down').removeClass('hide');
      $(this).parent().find('.menu-container-them').removeClass('m-hide-thematique');
    }else{
      $(this).parent().find('.menu-container-them').addClass('m-hide-thematique');
      $(this).find('.ad-caret-up').removeClass('hide');
      $(this).find('.ad-caret-down').addClass('hide');
    }
  });
 
  $('.gotopage').click(function(e){
    e.preventDefault();
    var numeropage = parseInt($(this).attr('data-page'));    
    $("#flipbook").turn("page", numeropage);
      $('.toggle-ongle-them + div').addClass('m-hide-thematique');
    $('.toggle-ongle-them + div').find('.ad-caret-up').removeClass('hide');
      $('.toggle-ongle-them + div').find('.ad-caret-down').addClass('hide');
  });
 $("#flipbook").bind("turning", function(event, page, view) {
   $('.next-page').show();
    $('.prev-page').show();
   var pageSelector = '.container-page.p'+ page + ' .content-page';  
   $(pageSelector).find('.swatch').each(function(){
     if($(this).attr('data-defaultselect') != 'true'){
       var swatchElement = $(this).find('.swatch-element').first().find('.swatchLbl');
       $(swatchElement).trigger('click');
     } 
    });
   $('.gotopage').each(function(){
      var minpage = parseInt($(this).attr('data-page'));
      var maxpage = minpage + parseInt($(this).attr('data-nbproduct'));
      console.log('page',page );
      if(page >= minpage && (page <= maxpage)){
        $(this).addClass('active');
      }else{
        $(this).removeClass('active');
      }
    });
 });
  
  $( window ).resize(function(){
   /* if($("#flipbook").length > 0)
      var pageelement = $('.turn-page-wrapper:visible')[0];
      
      var contentpage = $(pageelement).find('.content-page');
  
      var oldhauteurPage = $(pageelement).outerHeight();
      var oldlargeurPage = $(pageelement).outerWidth();
     
      
      var newlargeurPage = $('#flipbook').outerWidth();
      var newhauteurPage = (oldhauteurPage*newlargeurPage)/oldlargeurPage;
    
      // à changer pour le resposive le 939
    if(newhauteurPage >= hauteurCatalogue){
       $("#flipbook").turn("size", newlargeurPage, newhauteurPage);      
    }else{
      $("#flipbook").turn("size", newlargeurPage, hauteurCatalogue);          
    } 
      
    
    $("#flipbook").turn("size", newlargeurPage, newhauteurPage);          
      
      $(".catalogue-container .onglet-thematique").width(newhauteurPage);*/


 if($("#flipbook").length > 0){
        var pageelement = $('.turn-page-wrapper:visible')[0];
      
        var contentpage = $(pageelement).find('.content-page');
  
      var oldhauteurPage = $(contentpage).outerHeight();
      var oldlargeurPage = $(contentpage).outerWidth();
     
      
      var newlargeurPage = $('.catalogue-content').outerWidth();
      var newhauteurPage = (oldhauteurPage*newlargeurPage)/oldlargeurPage;
  
     
      if(oldhauteurPage != newhauteurPage){
       
      
     // $("#flipbook").turn("size", newlargeurPage, newhauteurPage);          
         
       if(largeurWindow >= 800 && newhauteurPage < hauteurCatalogue){
        $("#flipbook").turn("size", newlargeurPage, hauteurCatalogue);
      }else{
        $("#flipbook").turn("size", newlargeurPage, newhauteurPage);   
      }
      

    }
   $(".catalogue-container .onglet-thematique").width(hauteurCatalogue);
      }
    
    

    
  });
  $("#flipbook").bind("turned", function(event, page, view) {
   var pageSelector = '.container-page.p'+ page + ' .content-page';  
    
    var hauteurPage = $(pageSelector).outerHeight();
    
    var largeurPage = $(pageSelector).outerWidth();

   var largeurWindow = window.innerWidth;

  if(largeurWindow >= 800 && hauteurPage < hauteurCatalogue){
    $("#flipbook").turn("size", largeurPage, hauteurCatalogue);
  }else{
    $("#flipbook").turn("size", largeurPage, hauteurPage);   
  }
   
             
   
   $(".catalogue-container .onglet-thematique").width(hauteurCatalogue);

    
   
  });
  
  
   $("#flipbook").bind("last", function(event, pageObject, turned){
    $('.next-page').css('display','none');
    
  });
   $("#flipbook").bind("first", function(event, pageObject, turned){
    $('.prev-page').css('display','none');
    
  });
   $('#easyorder-popup-holder').on('DOMSubtreeModified', function(){
 
    if($('html').attr('lang') == 'en'){
       $('.easyorder-body_field select[name*="language_"]').val('1674678362440');
    }else{
       $('.easyorder-body_field select[name*="language_"]').val('1674678360249');
    }
   
  });
 }
});
//# sourceMappingURL=/s/files/1/0347/0567/0203/t/32/assets/custom.js.map?v=1628596268
  function handleResponse() {
    var htmlcart = JSON.parse(this.responseText);
    $("#cart-drawer .lis_sls").html(htmlcart['trylea-minicart']);
    $('body').removeClass('loading');
    if(window.location.pathname != '/cart' && window.location.pathname != '/en/cart' && window.location.href != 'https://printeddecor.com/cart'){
      $("#cart-drawer").addClass('active');
    }
    var cartcount = htmlcart['trylea-cartcount'].replace(/\D/g,'');
    $("#CartCount").html(cartcount);
    var sousTotal = htmlcart['trylea-carttotal'];
    $('.sub-total-mini-cart').html(sousTotal);
    if(window.location.pathname == '/cart' || window.location.pathname == '/en/cart'){
      var cartcontent = htmlcart['trylea-cartcontent'];
      var carttotal = htmlcart['trylea-cartsubtotal'];
      $('.cart-content-container').html(cartcontent);
      $('.cart-subtotal-container').html(carttotal);
    }
  } 
  function updateminicartcontent(){  
    const request = new XMLHttpRequest();
    request.addEventListener('load', handleResponse);
   console.log('location', window.location.pathname);
     if(window.location.pathname == '/cart' || window.location.pathname == '/en/cart'){ 
      // window.location.reload();
     if($('html').attr('lang') == 'en' && window.location.hostname == 'decorimprime.com'){
     
       request.open('GET', '/en/?sections=trylea-minicart,trylea-cartcount,trylea-carttotal,trylea-cartcontent,trylea-cartsubtotal', true); 
     }else{
       request.open('GET', '/?sections=trylea-minicart,trylea-cartcount,trylea-carttotal,trylea-cartcontent,trylea-cartsubtotal', true);
     }
    }else{
      if($('html').attr('lang') == 'en' && window.location.hostname == 'decorimprime.com'){
        
         request.open('GET', '/en/?sections=trylea-minicart,trylea-cartcount,trylea-carttotal', true);
      }else{
       request.open('GET', '/?sections=trylea-minicart,trylea-cartcount,trylea-carttotal', true);
      } 
    }
    
    request.send();
  }
  function removeItem(elmt){
    $('body').addClass('loading');
     var keyItem = $(elmt).attr('data-cart-key');
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {'id': keyItem, 'quantity': 0},
      dataType: "json",
      error: function (t) {
         console.log('Erreur');
      },
      success: function (e) {
          updateminicartcontent() ;
      },
    })
  }
 function updateQuantity(elmt){
   $('body').addClass('loading');
     var newQuantity = parseInt($(elmt).attr('data-cart-new-quantity'));
     var keyItem = $(elmt).attr('data-cart-key');
             
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {'id': keyItem, 'quantity': newQuantity},
      dataType: "json",
      error: function (t) {
         console.log('Erreur');
      },
      success: function (e) {
          updateminicartcontent() ;
      },
    })    
   }
   
jQuery("document").ready(function ($) {
    //Si on est en page produit
    if ($("body").hasClass("template-product")) {
        //Répercute la valeur du champs input dans le champs input caché. Sinon, pas pris en compte dans le panier.
        //Utile sur les produits sans variante
        $(".product-single__quantity #Quantity").on("change keydown paste input", function () {
            var quantity = $(this).val();
            $(".product-options-default-only .product-option-quantity").val(quantity);
        });

        //Modification du comportement lors du click sur l'image principale
        var $main_img = $(".product-gallery--media-wrapper");
        $main_img.on("click", function () {
            toggle_click_next_thumbnail();
           
        });

        function toggle_click_next_thumbnail() {
            var $all_thumbnails = $(".product-gallery--navigation > button");
            $all_thumbnails.each(function () {
                var is_selected = $(this).attr("data-product-gallery-selected");
                if (is_selected == "true") {
                    $(this).next().click();
                    return false;
                }
            });
        }

        /*
    //Au chargement de la page on met à jour le bouton
    var intervalId = window.setInterval(function(){
      updateLabelBtnCart();
    }, 500);

    //On stop la loop au bout de 10secondes
    setTimeout(function(){ clearInterval(intervalId); }, 10000);

  	//Puis on met à jour au click sur l'ajout d'échantillon
    $(document).on('click', 'button.product-samples-button, .product-samples-item__remove', function(){
      if ($(this).hasClass('product-samples-button')){ var timer = 1500; } else { var timer = 500;  }
      	setTimeout(function(){
			updateLabelBtnCart();
        }, timer);
    });

    function updateLabelBtnCart(){
      if (checkSample() != 0 && checkSample() != false) {
          var count_sample = checkSample();
          var $btn_cart = $('.product-samples-widget__modal').find('button.product-samples-widget__checkout');
          var text_btn_cart = $btn_cart.text();
		  var current_price_splited = text_btn_cart.split('$');
		  var current_price = current_price_splited[0];
          var total_price = 5 * count_sample;
          var nex_text_btn_cart = total_price + '$ - ' + text_btn_cart;
        if (text_btn_cart.indexOf('$') == -1 || current_price != total_price ) {
          $btn_cart.text(nex_text_btn_cart);
        }
      }
    }

	//Check si il y a le module échantillon
    function checkSample() {
      if ($('.product-samples-widget').length > -1 ) {
        var count_sample = 0;
        $('.product-samples-widget__modal').find('.product-samples-widget__grid > .product-samples-item').each(function(){
          count_sample++;
        });
        return count_sample;
      }
      return false;
    }
    */
    }
});